import React from "react";
import { Link } from "react-router-dom";
import "./Thanks.css";

function Thanks() {
  return (
    <div className="thanks-page">
      <h1>Thanks for your submission!</h1>
      <p>We’ll get back to you soon — can’t wait to work together.</p>
      <Link to="/" className="back-home">
        Back to Home
      </Link>
    </div>
  );
}

export default Thanks;
